// [PriceIncrease] Batch 2 - Update subscription page (BOOST-23879)
//
// Batch 2 stores are identified by the invoice's `extraFeePhaseVersion: 2` field
// (returned by the backend), not by a general store-domain list. Any invoice with
// extraFeePhaseVersion 2 and isExtraFeeCharged/upcoming price change is a Batch 2
// store; the list below only distinguishes the "special case" segment within Batch 2.
//
// Special case merchant: gains less value than the cost they pay -> moving to GMV pricing is a loss for them.
// Same Subscription page treatment as GENERAL_SPECIAL_PRICING_CHANGE_STORE
// (notify only, no auto upgrade to GMV pricing).
export const BATCH_2_GENERAL_SPECIAL_PRICING_CHANGE_STORE = [
  'bc-dev-v2-irene29.myshopify.com',
  'bc-dev-v2-irene42.myshopify.com',
  '001u13-04.myshopify.com',
  '0045e8-jb.myshopify.com',
  '00ntqd-kz.myshopify.com',
  '0241e8-6d.myshopify.com',
  '10ccec-e9.myshopify.com',
  '189c84-5.myshopify.com',
  '1rsy1d-0p.myshopify.com',
  '3-rivers-outdoor-co.myshopify.com',
  '3f06ca-db.myshopify.com',
  '3itt14-w4.myshopify.com',
  '3z-dental.myshopify.com',
  '4468ca-30.myshopify.com',
  '6dccde-f1.myshopify.com',
  '77d065-57.myshopify.com',
  '7e1c41-4.myshopify.com',
  '9daf09-4.myshopify.com',
  'aaa-corporate-online-store.myshopify.com',
  'af6fa9-b4.myshopify.com',
  'als-hardware-za.myshopify.com',
  'amrgazzazstore.myshopify.com',
  'artnhobby.myshopify.com',
  'arugs.myshopify.com',
  'aslanjewelers.myshopify.com',
  'aspenpublishing-development.myshopify.com',
  'babybabycoolbbc.myshopify.com',
  'bd6qew-01.myshopify.com',
  'bellecose-usd.myshopify.com',
  'bijouterie-jc-lambert-sprl.myshopify.com',
  'bjafnl.myshopify.com',
  'bounce-mkt.myshopify.com',
  'bradlands-pet-supplies.myshopify.com',
  'branded-beauty-store.myshopify.com',
  'brookstone-prod.myshopify.com',
  'c91efd-aa.myshopify.com',
  'cant-stop-kayaking-llc.myshopify.com',
  'carrington-lighting.myshopify.com',
  'cdsvinyljapanstore.myshopify.com',
  'collab-furniture.myshopify.com',
  'craft-online.myshopify.com',
  'cutting-tool-pickers-1.myshopify.com',
  'cygnett-nz.myshopify.com',
  'cygnettuk.myshopify.com',
  'd37bc4.myshopify.com',
  'd56com.myshopify.com',
  'd7mvdu-fh.myshopify.com',
  'david07.myshopify.com',
  'dd86rj-0y.myshopify.com',
  'demonpowersports.myshopify.com',
  'eb15e1-32.myshopify.com',
  'eliquids-outlet.myshopify.com',
  'everystreet.myshopify.com',
  'fabric-for-events.myshopify.com',
  'femme-dev.myshopify.com',
  'ffj-photo.myshopify.com',
  'fifthsun-costco.myshopify.com',
  'five-star-jewelry-brokers.myshopify.com',
  'florian-shoes-2.myshopify.com',
  'focpt.myshopify.com',
  'fox-apparel-black-friday.myshopify.com',
  'frisco-garden.myshopify.com',
  'froolu.myshopify.com',
  'fxr-racing-ca-dev.myshopify.com',
  'fxr-racing-the-last-lap.myshopify.com',
  'go-sport-iraq.myshopify.com',
  'goddess-isis-books-and-gifts.myshopify.com',
  'grandjesterstudios.myshopify.com',
  'hairdousa.myshopify.com',
  'hautloomcom.myshopify.com',
  'hemleyskateboarding.myshopify.com',
  'hhitsk-1g.myshopify.com',
  'hydropeptideprodev.myshopify.com',
  'icouniformsb2b.myshopify.com',
  'jackson-emea-dev1.myshopify.com',
  'jackson-us-dev1.myshopify.com',
  'jacksonshardware.myshopify.com',
  'japanny.myshopify.com',
  'jet-city-products-llc.myshopify.com',
  'jewellery-plus-store.myshopify.com',
  'jh-young-and-sons.myshopify.com',
  'juwelier-goldkleid.myshopify.com',
  'kindlehouse.myshopify.com',
  'kingsland-de.myshopify.com',
  'kingston-costco.myshopify.com',
  'lamour-le-allure.myshopify.com',
  'lavishspecs.myshopify.com',
  'loveraid.myshopify.com',
  'marzocchi-australia.myshopify.com',
  'menmomswebstore.myshopify.com',
  'merimbula-jewellers.myshopify.com',
  'metamark-non-trans-prod.myshopify.com',
  'millsandboonuk-staging.myshopify.com',
  'momqueenboutique.myshopify.com',
  'mont-usa.myshopify.com',
  'moomin-shop-morocco.myshopify.com',
  'mr-raeder.myshopify.com',
  'mr-roses-ro.myshopify.com',
  'my-little-korner.myshopify.com',
  'nanouniverse-stg.myshopify.com',
  'nazarsandco.myshopify.com',
  'nelsoncoleman.myshopify.com',
  'new2you-lx.myshopify.com',
  'newcag.myshopify.com',
  'o13-x-bgmotorsport.myshopify.com',
  'oceancityjewelers.myshopify.com',
  'octaveexceed.myshopify.com',
  'ososdepeluche-es.myshopify.com',
  'outfits-24.myshopify.com',
  'panachebysharmeen.myshopify.com',
  'paul-bensel-jewelers.myshopify.com',
  'pixemix.myshopify.com',
  'pljapan.myshopify.com',
  'presonus-us-dev1.myshopify.com',
  'ragesa.myshopify.com',
  'raleighagencies.myshopify.com',
  'raregearusa.myshopify.com',
  'rebelbod.myshopify.com',
  'reiners-fine-jewelers.myshopify.com',
  'remedynw.myshopify.com',
  'restaurantware-ae.myshopify.com',
  'rf-australia.myshopify.com',
  'richardsons-jewellers.myshopify.com',
  'ride-concepts-australia.myshopify.com',
  'ride-customs.myshopify.com',
  'ridefox-us-staging.myshopify.com',
  'rw-jetfresh.myshopify.com',
  'saliving.myshopify.com',
  'school-of-rock-gearselect.myshopify.com',
  'schutique-shoes.myshopify.com',
  'seamsfriendly-india.myshopify.com',
  'select-rugs-ca.myshopify.com',
  'shop-bobbys.myshopify.com',
  'shopatdean.myshopify.com',
  'signedshop.myshopify.com',
  'snap-distribution.myshopify.com',
  'sole-distribution-nz.myshopify.com',
  'sophias-costume.myshopify.com',
  'stafford-jewellers.myshopify.com',
  'staging4hiyaku.myshopify.com',
  'stagingusj.myshopify.com',
  'stay-strong-b2b-uk.myshopify.com',
  'store-sylvanianfamilies-id.myshopify.com',
  'swaemk-8y.myshopify.com',
  'swales-jewellers.myshopify.com',
  'taylored-fine-jewellery.myshopify.com',
  'tekled-illuminacion.myshopify.com',
  'terramar-sports-b2b.myshopify.com',
  'thames-hudson-au.myshopify.com',
  'the-boot-jack.myshopify.com',
  'thorlo-socks-b2b.myshopify.com',
  'truefashionistas.myshopify.com',
  'tupperware-brazil.myshopify.com',
  'twf-india.myshopify.com',
  'tyc3939.myshopify.com',
  'uf-morocco.myshopify.com',
  'ujh6zq-pa.myshopify.com',
  'unepiece-dev.myshopify.com',
  'up1a2i-iw.myshopify.com',
  'urban-accessories-nyc.myshopify.com',
  'victor-sports-uk.myshopify.com',
  'wantable-admin.myshopify.com',
  'wav8wm-65.myshopify.com',
  'weaeip-mi.myshopify.com',
  'whitakers-jewellery.myshopify.com',
  'word-on-fire-testing.myshopify.com',
  'www-yarnicorn-dk.myshopify.com',
  'xn-9dbcik0a.myshopify.com',
  'yarrawonga-showcase-jewellers.myshopify.com',
  'zimmerli-markets-test.myshopify.com',
  'znoogle.myshopify.com',
  'zydusonline.myshopify.com',
  'zynwholesale.myshopify.com',
];
